<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Dharam</h1>

        </div>
    </div>
</div>

<div class="el-blog-single-wrapper el-event-wrapper dashboard-box">
    <div class="container">
        <div class="row gy-4">

            <div class="col-lg-3 col-md-12">
                <div class="el-blog-sidebar-main">
                    <div class="el-inner-blog-box el-search-widget">
                        <a><img src="../assets/images/all-instructor/logo.svg" alt="logo"></a>
                        <!-- <h4 class="el-blog-title">Silverzone Olympiad</h4> -->


                    </div>
                    <div class="el-inner-blog-box el-category-widget">
                        <div class="el-blogs-cmts-img ">
                            <img src="../assets/images/all-instructor/comment1.jpg" alt="">
                        </div>
                        <h4 class="el-blog-title">Pappu kumar</h4>
                        <ul>
                            <li>
                                <a href="javascript:;">
                                    <i class="fa fa-envelope"></i>
                                    pk.silverzonegmail.com
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <i class="fa fa-user"></i>
                                    Student Id: 69086810
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <i class="fa fa-phone"></i>
                                    8920074764
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <i class="fa fa-graduation-cap"></i>
                                    Class 6th
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <i class="fa fa-building"></i>
                                    dav School
                                </a>
                            </li>

                        </ul>
                    </div>
                    <div class="el-inner-blog-box el-category-widget">
                        <h4 class="el-blog-title">Profile</h4>
                        <ul>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    My-Plan
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    View report
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    View Rank
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    My Result
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Add Sibling
                                </a>
                            </li>
                            <li>
                                <a href="javascript:;">
                                    <svg version="1.1" x="0" y="0" viewBox="0 0 491.996 491.996"
                                        style="enable-background:new 0 0 512 512">
                                        <g>
                                            <path
                                                d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                opacity="1"></path>
                                        </g>
                                    </svg>
                                    Log Out
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="el-blog-box el-blog-box-2 el-course-single-wrapper">
                    <!-- <div class="el-blog-img">
                        <img src="../assets/images/all-instructor/blog-4.jpg" alt="Blog Image">
                        <h4>Meta technology</h4>
                    </div> -->
                    <div class="el-blog-content ">
                        <div class="el-course-price ">
                            <h4 class="el-blog-title">My Plan</h4>

                        </div>
                        <div class="el-course-single-flex">
                            <div class="el-course-sngle-left">
                                <div class="el-course-sngle-teach">
                                    Detail Contant
                                </div>
                            </div>

                        </div>
                        <!-- Tab Start -->
                        <div class="el-course-sngle-tab-parent">
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="descrptn-tab" data-bs-toggle="tab"
                                        data-bs-target="#descrptn" type="button" role="tab" aria-controls="descrptn"
                                        aria-selected="false">description</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="student-tab" data-bs-toggle="tab"
                                        data-bs-target="#student" type="button" role="tab" aria-controls="student"
                                        aria-selected="false">students</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="news-tab" data-bs-toggle="tab"
                                        data-bs-target="#news" type="button" role="tab" aria-controls="news"
                                        aria-selected="true">news</button>
                                </li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane fade" id="descrptn" role="tabpanel" aria-labelledby="descrptn-tab">
                                    <div class="el-cours-sngle-tab-content">
                                        <h4 class="el-blog-title">about course</h4>
                                        <p class="el-para">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Praesent vehicula mauris ac facilisis congue. Fusce sem enim, rhoncus
                                            volutpat condimentum ac, placerat semper ligula. Suspendisse in viverra
                                            justo, eu placerat urna. Vestibulum blandit diam suscipit nibh mattis
                                            ullamcorper. Nullam a condimentum nulla, ut facilisis enim. Aliquam sagittis
                                            ipsum ex, sed luctus augue venenatis ut. Fusce at rutrum tellus, ac
                                            elementum neque. In nec velit orci. Etiam purus felis, pellentesque sit amet
                                            tincidunt at, iaculis quis erat. Morbi imperdiet sodales sapien nec rhoncus.
                                            Donec placerat mi et libero iaculis, id maximus est vestibulum. Etiam augue
                                            augue, auctor at ornare eget, porta ac nisl. Aliquam et mattis dolor, et
                                            aliquet ligula.</p>
                                        <p class="el-para">Nam id ligula tristique, porta dolor ac, pretium leo.
                                            Maecenas scelerisque vulputate dapibus. Quisque sodales tincidunt sapien, eu
                                            consequat erat tempus et. Nullam ipsum est, interdum quis posuere sed,
                                            imperdiet
                                            quis nisi. pulvinar est at, commodo mauris. Nunc in mollis erat. Integer
                                            aliquet orci non auctor pretium.Proin quis justo est. Vestibulum imperdiet
                                            leo sit amet tortor suscipit, id cursus ligula pharetra.
                                            Uctus ac eros a, faucibus iaculis quam. Nam non iaculis justo. Donec maximus
                                            varius velit.</p>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="student" role="tabpanel" aria-labelledby="student-tab">
                                    <div class="el-course-sngle-students">
                                        <div class="el-course-price el-cusrs-sngle-head">
                                            <h4 class="el-blog-title">total students</h4>
                                            <span>25</span>
                                        </div>
                                        <div class="el-course-sngle-student-list">
                                            <h4>05 students recently join this course</h4>
                                            <ul>
                                                <li>
                                                    <div class="el-curs-stnds-list">
                                                        <img src="../assets/images/all-instructor/stdnt1.png"
                                                            alt="image">
                                                        <div class="el-crs-stdnt-info">
                                                            <h4>lavern gunner</h4>
                                                            <p class="el-para">new student</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="el-curs-stnds-list">
                                                        <img src="../assets/images/all-instructor/stdnt2.png"
                                                            alt="image">
                                                        <div class="el-crs-stdnt-info">
                                                            <h4>carney Tate</h4>
                                                            <p class="el-para">new student</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="el-curs-stnds-list">
                                                        <img src="../assets/images/all-instructor/stdnt3.png"
                                                            alt="image">
                                                        <div class="el-crs-stdnt-info">
                                                            <h4>elbert wade</h4>
                                                            <p class="el-para">new student</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="el-curs-stnds-list">
                                                        <img src="../assets/images/all-instructor/stdnt4.png"
                                                            alt="image">
                                                        <div class="el-crs-stdnt-info">
                                                            <h4>baldwin dallas</h4>
                                                            <p class="el-para">new student</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="el-curs-stnds-list">
                                                        <img src="../assets/images/all-instructor/t1.jpg" alt="image">
                                                        <div class="el-crs-stdnt-info">
                                                            <h4>graham ryder</h4>
                                                            <p class="el-para">new student</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div class="el-blog-bottom-pagination">
                                                <nav>
                                                    <ul class="pagination">
                                                        <li><a href="javascript:;">1</a></li>
                                                        <li><a href="javascript:;">2</a></li>
                                                        <li><a href="javascript:;">3</a></li>
                                                        <li class="active">
                                                            <a href="javascript:;">
                                                                <svg version="1.1" x="0" y="0"
                                                                    viewBox="0 0 491.996 491.996"
                                                                    style="enable-background:new 0 0 512 512">
                                                                    <g>
                                                                        <path
                                                                            d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                                                            opacity="1"></path>
                                                                    </g>
                                                                </svg>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade active show" id="news" role="tabpanel"
                                    aria-labelledby="news-tab">
                                    <div class="el-cours-sngle-tab-content">
                                        <h4 class="el-blog-title">course news</h4>
                                        <h6>some recent news about this course....</h6>
                                        <p class="el-para">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Praesent vehicula mauris ac facilisis congue. Fusce sem enim, rhoncus
                                            volutpat condimentum ac, placerat semper ligula. Suspendisse in viverra
                                            justo, eu placerat urna. Vestibulum blandit diam suscipit nibh mattis
                                            ullamcorper. Nullam a condimentum nulla, ut facilisis enim. Aliquam sagittis
                                            ipsum ex, sed luctus augue venenatis ut. Fusce at rutrum tellus, ac
                                            elementum neque. In nec velit orci. Etiam purus felis, pellentesque sit amet
                                            tincidunt at, iaculis quis erat. Morbi imperdiet sodales sapien nec rhoncus.
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tab End -->
                    </div>
                    <!-- <div class="el-lesson-parent">
                        <ul>
                            <li><a
                                    href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">lessons</a>
                                <span>Estimated time</span>
                            </li>
                            <li><a href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">development
                                    overview</a> <span>1 Hourse 10 Minuts</span></li>
                            <li><a href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">basic
                                    html</a> <span>2 Hourse 30 Minuts</span></li>
                            <li><a href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Basic
                                    CSS</a> <span>3 Hourse 15 Minuts</span></li>
                            <li><a href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Advanced
                                    HTML + CSS</a> <span>1 Hourse 30 Minuts</span></li>
                            <li><a
                                    href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Javascript</a>
                                <span>2 Hourse 45 Minuts</span>
                            </li>
                        </ul>
                    </div> -->
                </div>
            </div>

        </div>
    </div>
</div>